import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { daysPerWeek, weekdays } from '@datapad/data-model';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { CalendarCell } from './CalendarCell.js';
function getEventsForDate(events, date) {
    return events.filter((event) => event.date.equals(date));
}
function getBirthdaysForDate(characters, date) {
    return characters.filter((character) => {
        const birthday = character.birthday;
        if (birthday === undefined) {
            return false;
        }
        return birthday.day === date.day;
    });
}
export function CalendarGrid(props) {
    const { dates, events, characters, currentDate, onDateClick } = props;
    const cellRefs = React.useRef([]);
    const handleGridKeyDown = React.useCallback((event) => {
        const focusedElement = document.activeElement;
        const currentIndex = cellRefs.current.findIndex((ref) => ref === focusedElement);
        if (currentIndex === -1)
            return;
        let nextIndex = null;
        switch (event.key) {
            case 'ArrowRight':
                if (currentIndex < dates.length - 1) {
                    nextIndex = currentIndex + 1;
                }
                break;
            case 'ArrowLeft':
                if (currentIndex > 0) {
                    nextIndex = currentIndex - 1;
                }
                break;
            case 'ArrowDown':
                if (currentIndex + daysPerWeek < dates.length) {
                    nextIndex = currentIndex + daysPerWeek;
                }
                break;
            case 'ArrowUp':
                if (currentIndex - daysPerWeek >= 0) {
                    nextIndex = currentIndex - daysPerWeek;
                }
                break;
            default:
                return;
        }
        if (nextIndex !== null) {
            event.preventDefault();
            cellRefs.current[nextIndex]?.focus();
        }
    }, [dates.length]);
    return (_jsxs(Box, { role: "grid", "aria-label": "Calendar grid", onKeyDown: handleGridKeyDown, sx: {
            display: 'grid',
            gridTemplateColumns: `repeat(${daysPerWeek}, 1fr)`,
            gap: 1,
            p: 2,
            width: '100%',
            boxSizing: 'border-box',
        }, children: [weekdays.map((weekday) => (_jsx(Box, { sx: {
                    textAlign: 'center',
                    py: 1,
                    borderBottom: 1,
                    borderColor: 'divider',
                    minWidth: 0,
                    overflow: 'hidden',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: 'background.paper',
                }, children: _jsx(Typography, { variant: "subtitle2", fontWeight: "bold", color: "text.primary", sx: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }, children: weekday }) }, weekday))), dates.map((date, index) => {
                const eventsOnDate = getEventsForDate(events, date);
                const birthdaysOnDate = getBirthdaysForDate(characters, date);
                const isCurrentDate = currentDate !== undefined && date.equals(currentDate);
                return (_jsx(CalendarCell, { ref: (el) => {
                        cellRefs.current[index] = el;
                    }, date: date, events: eventsOnDate, birthdays: birthdaysOnDate, isCurrentDate: isCurrentDate, onClick: () => onDateClick(date) }, `${date.year}-${date.day}`));
            })] }));
}
//# sourceMappingURL=CalendarGrid.js.map